import { Card, CardHeader } from "@mui/material";
import { UserContext } from "App";
import SessionsApi from "Classes/API/Administration/SessionsApi";
import UsersApi from "Classes/API/UsersApi";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Loader from "layouts/loader/loader";
import React, { useContext, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getStorage, ref, deleteObject } from "firebase/storage";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import EntryFile from "./EntryFile";
import { LanguageContext } from "App";

const PatientEntries = () => {
  const { translations } = useContext(LanguageContext);
  const { id } = useParams();
  const [entries, setEntries] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const User = useContext(UserContext);
  const storage = getStorage();
  const { state } = useLocation();
  console.log("state", state);
  const getHistoryEntries = async (patientId) => {
    setLoading(true);
    try {
      var req = {
        patientId: patientId,
        pagingParams: {
          pageNumber: 1,
          pageSize: 100,
        },
      };

      UsersApi.SearchPatientHistoryEntries(req).then((res) => {
        if (res.data.list.length > 0) {
          console.log(res.data.list);

          let userTherapistId = User.getTherapist ? User.getTherapist.id : null;

          if (userTherapistId) {
            let tempResponseData = [];
            for (let i = 0; i < res.data.list.length; i++) {
              // if (res.data.list[i].TherapistId === userTherapistId) {
              // If therapistId matches, push the item to tempResponseData
              tempResponseData.push(res.data.list[i]);
              // }
            }
            setEntries(tempResponseData);
          } else {
            setEntries(res.data.list);
          }

          setLoading(false);
        } else {
          setEntries([]);
          setLoading(false);
        }
      });
    } catch (error) {
      console.error("Error fetching patient data:", error);
    }
  };

  const deleteEntry = async (entryId) => {
    let result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) {
      return;
    }

    Swal.fire({
      title: "Deleting...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // delete from firebase if there is a path
    var entry = entries.find((e) => e.id === entryId);
    if (entry.fileUrl != null && entry.filePath != null) {
      const storageRef = ref(storage, entry.filePath);
      try {
        await deleteObject(storageRef);
      } catch (error) {
        console.error("Error deleting file from storage:", error);
      }
    }

    var req = {
      SearchInt: entryId,
    };

    var res = await UsersApi.DeletePatientHistoryEntry(req);

    if (res.status == "Success") {
      Swal.fire({
        title: "Deleted!",
        text: "Entry has been deleted.",
        icon: "success",
        confirmButtonText: "Ok",
      });
      getHistoryEntries(id);
    } else {
      Swal.fire({
        title: "Error",
        text: "Error Deleting Entry",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  useEffect(() => {
    getHistoryEntries(id);
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div
            className="EntriesHeader"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              textAlign: "center",
              borderBottom: "1px solid #0000001c",
              marginBottom: "10px",
            }}
          >
            <MDButton
              onClick={() => window.history.back()}
              fontWeight="medium"
              color="info"
              variant="outlined"
            >
              {translations.Back}
            </MDButton>
            <h1>{state?.patient != null ? state.patient.name : "Patient"}</h1>
            <MDButton
              onClick={() => window.location.replace("../CreateEntry/" + id)}
              fontWeight="medium"
              color="success"
              variant="outlined"
            >
              {translations.CreateEntry}
            </MDButton>
          </div>

          {entries.length === 0 && (
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <MDBox mb={3} sx={{ display: "flex", justifyContent: "space-around" }}>
                    <MDTypography variant="h6" fontWeight="medium">
                      {translations.NoEntriesFound}
                    </MDTypography>
                  </MDBox>
                </div>
              </div>
            </div>
          )}

          {entries.length > 0 && (
            <div className="container">
              {entries.map((entry, index) => (
                <div className="row" key={entry.id}>
                  <div className="col-md-12">
                    <Card sx={{ padding: "1em", margin: "1em 0 0 0" }}>
                      {entry?.getTherapist != null && (
                        <CardHeader
                          title={`Entry ID: ${entry.id}  ---  Therapist: ${entry?.getTherapist?.getUser?.name}`}
                        />
                      )}
                      <MDBox p={2}>
                        {/* {entry.getEntryFiles.map((file) => (
                                                    <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                                                        {file.fileType.startsWith('image/') ? (
                                                            <img
                                                                src={"data:image/png;base64," + file.file}
                                                                alt={file.fileName}
                                                                style={{ maxWidth: '100%', maxHeight: '300px', marginBottom: '10px' }}
                                                            />
                                                        ) : (
                                                            <>
                                                                <MDTypography variant="body2" mb={1}><strong>File:</strong> {file.fileName}</MDTypography>
                                                                <MDButton
                                                                    onClick={() => {
                                                                        DownloadFileClick(file.id, file.fileName);
                                                                    }}
                                                                    fontWeight="medium"
                                                                >
                                                                    Download
                                                                </MDButton>
                                                            </>
                                                        )}
                                                    </div>
                                                ))} */}
                        {
                          // entry.fileUrl &&
                          // <div style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                          //     {
                          //         <img
                          //         src={entry.fileUrl}
                          //         style={{ maxWidth: '100%', maxHeight: '300px', marginBottom: '10px' }}
                          //     />}
                          // </div>
                          // getFileDiv(entry)
                          <EntryFile entry={entry} />
                        }
                        <MDTypography variant="body2" mb={2}>
                          <br />
                          <h5> {entry.notes} </h5>
                        </MDTypography>
                        {(entry.therapistId == User.getTherapist?.id ||
                          User.userType == "Admin") && (
                          <button
                            onClick={() => deleteEntry(entry.id)}
                            className="btn btn-sm btn-danger"
                            style={{ marginTop: "10px" }}
                          >
                            {translations.Delete}
                          </button>
                        )}
                      </MDBox>
                    </Card>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default PatientEntries;
